import { Directive, ElementRef, HostListener, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import {
  FlexibleConnectedPositionStrategy,
  Overlay,
  OverlayConfig,
  OverlayRef
} from '@angular/cdk/overlay';
import { ComponentPortal, ComponentType } from '@angular/cdk/portal';

import { TooltipComponent } from '../components/tooltip/tooltip.component';

@Directive({
  selector: '[mcraiTooltip]'
})
export class TooltipDirective {
  private _overlayRef: OverlayRef;

  @Input() set mcraiTooltip(value: TemplateRef<any> | string) {
    this.content = value;
  }

  @Input() content: TemplateRef<any> | string;
  @Input() width: number;

  constructor(
    private _overlay: Overlay,
    private _viewRef: ViewContainerRef,
    private _elRef: ElementRef
  ) { }

  private _getPosition(): FlexibleConnectedPositionStrategy {
    return this._overlay
      .position()
      .flexibleConnectedTo(this._elRef)
      .withPositions([
        { originX: 'end', originY: 'top', overlayX: 'start', overlayY: 'bottom', weight: 1, offsetX: 5, offsetY: -5 },
        { originX: 'end', originY: 'bottom', overlayX: 'start', overlayY: 'top', weight: 2, offsetX: 5, offsetY: 5 },
        { originX: 'start', originY: 'top', overlayX: 'end', overlayY: 'bottom', weight: 3, offsetX: -5, offsetY: -5 },
        { originX: 'start', originY: 'bottom', overlayX: 'end', overlayY: 'top', weight: 4, offsetX: -5, offsetY: 5 },
      ]);
  }

  private _getConfig(): OverlayConfig {
    const config = {
      positionStrategy: this._getPosition(),
    };

    if (this.width) {
      Object.assign(config, {
        maxWidth: this.width,
        width: '100%'
      });
    }

    return new OverlayConfig(config);
  }

  private _getPortal<T>(component: ComponentType<T>): ComponentPortal<T> {
    return new ComponentPortal<T>(component);
  }

  private _createOverlay(): OverlayRef {
    return this._overlay.create(this._getConfig());
  }

  @HostListener('mouseenter')
  public onMouseEnter(): void {
    this._overlayRef = this._createOverlay();

    this._overlayRef.attach(this._getPortal(TooltipComponent))
      .instance
      .withContent(this.content);
  }

  @HostListener('mouseleave')
  public onMouseLeave(): void {
    this._overlayRef.dispose();
  }

}
